import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Routes, useLocation } from "react-router-dom";

// Wraps the app's <Route> elements with a fade/slide transition on route change.
// Routes is pinned to a snapshotted `location` so the outgoing page keeps rendering
// its old content while it animates out, instead of switching to the new route
// content instantly and only fading the (already-new) DOM.
const PageTransition = ({ children }) => {
  const location = useLocation();

  // React Router never resets scroll on navigation — without this, clicking a
  // "Get Details" card while scrolled down on the homepage lands on the new
  // page at that same scroll offset, which looks like it opened at the bottom.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.22, ease: "easeInOut" }}
      >
        <Routes location={location}>{children}</Routes>
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
